"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BackgroundBlurProcessorProvided_1 = require("./BackgroundBlurProcessorProvided");

var BackgroundBlurStrength_1 = require("./BackgroundBlurStrength");
/**
 * The [[BackgroundBlurProcessorBuiltIn]] uses the browser's built-in capability to apply blurring to
 * the background image as apposed to [[BackgroundBlurProcessorProvided]] that uses WASM and
 * TensorFlow Lite to apply the blur.
 */

/** @internal */


var BackgroundBlurProcessorBuiltIn = /*#__PURE__*/function (_BackgroundBlurProces) {
  _inherits(BackgroundBlurProcessorBuiltIn, _BackgroundBlurProces);

  var _super2 = _createSuper(BackgroundBlurProcessorBuiltIn);

  /**
   * A constructor that will apply default values if spec and strength are not provided.
   * If no spec is provided the selfie segmentation model is used with default paths to CDN for the
   * worker and wasm files used to process each frame.
   * @param spec The spec defines the assets that will be used for adding background blur to a frame.
   * @param options How much blur to apply to a frame.
   */
  function BackgroundBlurProcessorBuiltIn(spec, options) {
    var _this;

    _classCallCheck(this, BackgroundBlurProcessorBuiltIn);

    _this = _super2.call(this, spec, options);
    _this.blurCanvas = document.createElement('canvas');
    _this.blurCanvasCtx = _this.blurCanvas.getContext('2d');
    _this.blurCanvas.width = _this.spec.model.input.width;
    _this.blurCanvas.height = _this.spec.model.input.height;

    _this.logger.info('BackgroundBlur processor using builtin blur');

    return _this;
  }

  _createClass(BackgroundBlurProcessorBuiltIn, [{
    key: "drawImageWithMask",
    value: function drawImageWithMask(inputCanvas, mask) {
      // Mask will not be set until the worker has completed handling the predict event. Until the first frame is processed,
      // the whole frame will be blurred.
      var blurredImage = this.blurredImage;
      var canvasCtx = this.canvasCtx,
          targetCanvas = this.targetCanvas;
      var width = targetCanvas.width,
          height = targetCanvas.height;

      if (!mask || !blurredImage) {
        canvasCtx.clearRect(0, 0, width, height);
        return;
      }

      var scaledCtx = this.scaledCanvas.getContext('2d');
      scaledCtx.putImageData(mask, 0, 0);
      this.blurCanvasCtx.putImageData(this.blurredImage, 0, 0); // draw the mask

      canvasCtx.save();
      canvasCtx.clearRect(0, 0, width, height);
      canvasCtx.drawImage(this.scaledCanvas, 0, 0, width, height); // Only overwrite existing pixels.

      canvasCtx.globalCompositeOperation = 'source-in'; // draw image over mask...

      canvasCtx.drawImage(inputCanvas, 0, 0, width, height); // draw under person

      canvasCtx.globalCompositeOperation = 'destination-over';
      canvasCtx.drawImage(this.blurCanvas, 0, 0, width, height);
      canvasCtx.restore();
    }
  }, {
    key: "setBlurStrength",
    value: function setBlurStrength(blurStrength) {
      _get(_getPrototypeOf(BackgroundBlurProcessorBuiltIn.prototype), "setBlurStrength", this).call(this, blurStrength);

      if (this.worker) {
        // live update
        this.modelInitialized = false;
        this.worker.postMessage({
          msg: 'destroy'
        });
        var model = this.spec.model;
        this.worker.postMessage({
          msg: 'loadModel',
          payload: {
            modelUrl: model.path,
            inputHeight: model.input.height,
            inputWidth: model.input.width,
            inputChannels: 4,
            modelRangeMin: model.input.range[0],
            modelRangeMax: model.input.range[1],
            blurPixels: this.blurAmount
          }
        });
      }
    }
  }, {
    key: "setBlurPixels",
    value: function setBlurPixels() {
      // the blurred image is sized down to 144, regardless of what the canvas size is, so
      // we use the default blur strengths (540p)
      this.blurAmount = BackgroundBlurStrength_1.BlurStrengthMapper.getBlurAmount(this._blurStrength, {
        height: 540
      });
      this.logger.info("background blur amount set to ".concat(this.blurAmount));
    }
  }, {
    key: "handleInitialize",
    value: function handleInitialize(msg) {
      this.logger.info("received initialize message: ".concat(this.stringify(msg)));

      if (!msg.payload) {
        this.logger.error('failed to initialize module');
        this.initWorkerPromise.reject(new Error('failed to initialize the module'));
        return;
      }

      var model = this.spec.model;
      this.worker.postMessage({
        msg: 'loadModel',
        payload: {
          modelUrl: model.path,
          inputHeight: model.input.height,
          inputWidth: model.input.width,
          inputChannels: 4,
          modelRangeMin: model.input.range[0],
          modelRangeMax: model.input.range[1],
          blurPixels: this.blurAmount
        }
      });
      this.initWorkerPromise.resolve({});
    }
  }, {
    key: "handlePredict",
    value: function handlePredict(msg) {
      this.blurredImage = msg.payload.blurOutput;

      _get(_getPrototypeOf(BackgroundBlurProcessorBuiltIn.prototype), "handlePredict", this).call(this, msg);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this2 = this;

      var _super = Object.create(null, {
        destroy: {
          get: function get() {
            return _get(_getPrototypeOf(BackgroundBlurProcessorBuiltIn.prototype), "destroy", _this2);
          }
        }
      });

      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _super.destroy.call(this);

                (_a = this.blurCanvas) === null || _a === void 0 ? void 0 : _a.remove();
                this.blurCanvas = undefined;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return BackgroundBlurProcessorBuiltIn;
}(BackgroundBlurProcessorProvided_1.default);

exports.default = BackgroundBlurProcessorBuiltIn;